import Vue from "vue";

export default {
    realizarAprovacao(processoOid) {
        return Vue.axios.post("aprovacao/" + processoOid);
    }
}
